import React from 'react';
import './scrollerFramer.css'

function C2wScrollerFramer() {


  const IOtArr = [
    'Iot-1.png',
    'Iot-2.png',
    'Iot-3.png',
    'IOT.png',
    'Iot-4.png',
    'Iot-5.png',
    'Iot-6.png',
    'IOT.png',
    'Iot-7.png',
    'Iot-8.png',
    'Iot-10.png',
    'IOT.png',
    'Iot-11.png',
    'Iot-12.png',
    'Iot-13.png',
    'IOT.png',
    'Iot-14.png',
    'Iot-15.png',
    'Iot-16.png',
    'IOT.png',
    'Iot-17.png',
    'Iot-18.png',
    'Iot-19.png',
    'IOT.png',
    'Iot-20.png',
    'Iot-21.png',
    'Iot-21.png',
    'Iot-22.png',
    'Iot-23.png',
    'IOT.png',
    'Iot-24.png',
    'Iot-25.png',
    'Iot-26.png',
    'IOT.png',
    'Iot-27.png',
    'Iot-28.png',
    'Iot-29.png',
    'IOT.png',
    'Iot-30.png',
    'Iot-31.png',
    'Iot-32.png',
    'IOT.png',
    'Iot-33.png',
    'Iot-34.png',
    'Iot-35.png',
    'IOT.png',
    'Iot-36.png',
    'Iot-37.png',
    'Iot-38.png',
    'IOT.png',
    'Iot-39.png',
    'Iot-41.png',
    'Iot-42.png',
    'IOT.png',
    'Iot-43.png',
    'Iot-44.png',
    'Iot-45.png',
    'IOT.png',
    'Iot-46.png',
    'Iot-47.png',
    'Iot-48.png',
    'IOT.png',
    'Iot-49.png',
    'Iot-50.png',
    'Iot-51.png',
    'IOT.png',
    'Iot-52.png',
    'Iot-53.png',
    'Iot-54.png',
    'Iot-55.png',
    'IOT.png',
    'Iot-56.png',
    'Iot-57.png',
    'Iot-58.png',
    'IOT.png',
    'Iot-59.png',
    'Iot-60.png',
   ]

  const pythonArr = [
      "python-42.png",
      "python-43.png",
      "python-44.png",
      "Python.png",
      "python-45.png",
      "python-46.png",
      "python-47.png",
      "Python.png",
      "python-48.png",
      "python-49.png",
      "python-50.png",
      "Python.png",
      "python-51.png",
      "python-52.png",
      "python-53.png",
      "Python.png",
      "python-54.png",
      "python-55.png",
      "python-56.png",
      "Python.png",
      "python-57.png",
      "python-58.png",
      "python-59.png",
      "Python.png",
      "python-60.png",
      "python-61.png",
      "python-62.png",
      "Python.png",
      "python-63.png",
      "python-64.png",
      "python-65.png",
      "Python.png",
      "python-66.png",
      "python-67.png",
      "python-68.png",
      "Python.png",
      "python-69.png",
      "python-70.png",
      "python-71.png",
      "Python.png",
      "python-2.png",
      "python-3.png",
      "Python.png",
      "python-4.png",
      "python-5.png",
      "Python.png",
      "python-7.png",
      "python-8.png",
      "python-9.png",
      "Python.png",
      "python-10.png",
      "python-11.png",
      "python-12.png",
      "Python.png",
      "python-13.png",
      "python-14.png",
      "python-15.png",
      "Python.png",
      "python-16.png",
      "python-17.png",
      "python-18.png",
      "Python.png",
      "python-19.png",
      "python-20.png",
      "python-21.png",
      "Python.png",
      "python-22.png",
      "python-23.png",
      "python-24.png",
      "Python.png",
      "python-25.png",
      "python-26.png",
      "python-27.png",
      "Python.png",
      "python-28.png",
      "python-29.png",
      "python-30.png",
      "Python.png",
      "python-31.png",
      "python-32.png",
      "python-33.png",
      "Python.png",
      "python-34.png",
      "python-35.png",
      "python-36.png",
      "Python.png",
      "python-37.png",
      "python-38.png",
      "python-39.png",
      "Python.png",
      "python-40.png",
      "python-41.png",

  ]

   const flutterArr = [
      "Flutter-35.png",
      "Flutter-36.png",
      "Flutter-37.png",
      "Flutter-38.png",
      "Flutter-39.png",
      "FLUTTER.png",
      "Flutter-40.png",
      "Flutter-41.png",
      "Flutter-42.jpeg",
      "Flutter-43.jpeg",
      "FLUTTER.png",
      "Flutter-44.jpeg",
      "Flutter-45.jpeg",
      "Flutter-46.jpeg",
      "Flutter-47.jpeg",
      "Flutter-48.jpeg",
      "FLUTTER.png",
      "Flutter-49.jpeg",
      "Flutter-50.jpeg",
      "Flutter-51.jpeg",
      "Flutter-52.jpeg",
      "Flutter-53.jpeg",
      "Flutter-54.jpeg",
      "FLUTTER.png",
      "Flutter-55.jpeg",
      "Flutter-56.jpeg",
      "Flutter-57.jpeg",
      "Flutter-58.jpeg",
      "FLUTTER.png",
      "Flutter-59.jpeg",
      "Flutter-60.jpeg",
      "Flutter-61.jpeg",
      "FLUTTER.png",
      "Flutter-1.png",
      "Flutter-2.png",
      "Flutter-3.png",
      "Flutter-4.png",
      "Flutter-5.png",
      "FLUTTER.png",
      "Flutter-6.png",
      "Flutter-7.png",
      "Flutter-8.png",
      "Flutter-9.png",
      "Flutter-10.png",
      "FLUTTER.png",
      "Flutter-11.png",
      "Flutter-12.png",
      "Flutter-13.png",
      "Flutter-14.png",
      "FLUTTER.png",
      "Flutter-16.png",
      "Flutter-17.png",
      "Flutter-18.png",
      "Flutter-19.png",
      "FLUTTER.png",
      "Flutter-20.png",
      "Flutter-21.png",
      "Flutter-22.png",
      "Flutter-23.png",
      "Flutter-24.png",
      "FLUTTER.png",
      "Flutter-25.png",
      "Flutter-26.png",
      "Flutter-27.png",
      "Flutter-28.png",
      "Flutter-29.png",
      "FLUTTER.png",
      "Flutter-30.png",
      "Flutter-31.png",
      "Flutter-32.png",
      "Flutter-33.png",
      "Flutter-34.png",
      "FLUTTER.png",
   ]

      
  const javaArr = [
    "JAVA.png",
    "Java-55.jpeg",
    "Java-56.jpeg",
    "Java-57.jpeg",
    "Java-58.jpeg",
    "Java-59.jpeg",
    "Java-60.jpeg",
    "JAVA.png",
    "Java-61.jpeg",
    "Java-121.jpeg",
    "Java-62.jpeg",
    "Java-63.jpeg",
    "Java-64.jpeg",
    "Java-65.jpeg",
    "Java-66.jpeg",
    "JAVA.png",
    "Java-67.jpeg",
    "Java-122.jpeg",
    "Java-68.jpeg",
    "Java-69.jpeg",
    "Java-70.jpeg",
    "Java-71.jpeg",
    "JAVA.png",
    "Java-72.jpeg",
    "Java-123.jpeg",
    "Java-73.jpeg",
    "Java-1.jpeg",
    "Java-2.jpeg",
    "Java-3.jpeg",
    "Java-4.jpeg",
    "Java-124.jpeg",
    "JAVA.png",
    "Java-5.jpeg",
    "Java-6.jpeg",
    "Java-7.jpeg",
    "Java-125.jpeg",
    "Java-8.jpeg",
    "Java-9.jpeg",
    "JAVA.png",
    "Java-10.jpeg",
    "Java-11.jpeg",
    "Java-126.jpeg",
    "Java-12.jpeg",
    "Java-13.jpeg",
    "Java-14.jpeg",
    "JAVA.png",
    "Java-15.jpeg",
    "Java-11.jpeg",
    "Java-127.jpeg",
    "Java-16.jpeg",
    "Java-17.jpeg",
    "Java-18.jpeg",
    "Java-19.jpeg",
    "Java-20.jpeg",
    "JAVA.png",
    "Java-21.jpeg",
    "Java-22.jpeg",
    "Java-23.jpeg",
    "Java-24.jpeg",
    "Java-25.jpeg",
    "Java-129.jpeg",
    "Java-26.jpeg",
    "JAVA.png",
    "Java-27.jpeg",
    "Java-28.jpeg",
    "Java-29.jpeg",
    "Java-30.jpeg",
    "Java-31.jpeg",
    "JAVA.png",
    "Java-32.jpeg",
    "Java-33.jpeg",
    "Java-34.jpeg",
    "Java-35.jpeg",
    "Java-36.jpeg",
    "Java-37.jpeg",
    "JAVA.png",
    "Java-38.jpeg",
    "Java-39.jpeg",
    "Java-41.jpeg",
    "Java-42.jpeg",
    "Java-43.jpeg",
    "JAVA.png",
    "Java-44.jpeg",
    "Java-45.jpeg",
    "Java-46.jpeg",
    "Java-47.jpeg",
    "Java-48.jpeg",
    "Java-49.jpeg",
    "Java-50.jpeg",
    "JAVA.png",
    "Java-51.jpeg",
    "Java-52.jpeg",
    "Java-53.jpeg",
    "Java-54.jpeg",
    "Java-74.jpeg",
    "Java-75.jpeg",
    "JAVA.png",
    "Java-76.jpeg",
    "Java-77.jpeg",
    "Java-78.jpeg",
    "Java-79.jpeg",
    "Java-80.jpeg",
    "Java-81.jpeg",
    "Java-82.jpeg",
    "JAVA.png",
    "Java-83.jpeg",
    "Java-84.jpeg",
    "Java-85.jpeg",
    "Java-86.jpeg",
    "Java-87.jpeg",
    "Java-88.jpeg",
    "JAVA.png",
    "Java-89.jpeg",
    "Java-90.jpeg",
    "Java-91.jpeg",
    "Java-92.jpeg",
    "Java-93.jpeg",
    "Java-94.jpeg",
    "Java-95.jpeg",
    "Java-96.jpeg",
    "JAVA.png",
    "Java-97.jpeg",
    "Java-98.jpeg",
    "Java-99.jpeg",
    "Java-100.jpeg",
    "Java-101.jpeg",
    "Java-102.jpeg",
    "JAVA.png",
    "Java-103.jpeg",
    "Java-104.jpeg",
    "Java-105.jpeg",
    "Java-106.jpeg",
    "Java-107.jpeg",
    "Java-108.jpeg",
    "JAVA.png",
    "Java-109.jpeg",
    "Java-110.jpeg",
    "Java-111.jpeg",
    "Java-112.jpeg",
    "Java-112.jpeg",
    "Java-113.jpeg",
    "JAVA.png",
    "Java-114.jpeg",
    "Java-130.jpeg",
    "Java-115.jpeg",
    "Java-116.jpeg",
    "Java-117.jpeg",
    "Java-118.jpeg",
    "Java-119.jpeg",
    "Java-120.jpeg",
   ]

  return (
    <div className='C2wScrollerFramer_ctn'>
        <div className='C2wGallery_heading'>{'Projects done by previous batch students under'}
          <img src='/assets/images/offlineCourseDetail/superx.png' />
        </div>
         <div className='C2wScrollerParallax C2wScrollerParallax2'>
            <div className='C2wImageScorller'>
               <span>
                { javaArr && javaArr?.map((url) => (
                <div style={{backgroundImage: `url(/assets/images/offlineCourseDetail/gallery/${url})`}}></div>
                 ))}
              </span>
            </div>
        </div>
        <div className='C2wScrollerParallax C2wScrollerParallax1'>
          {/* IOT Superx and with three thumbnail from each photos  */}
            <div className='C2wImageScorller'>
              <span>
                { IOtArr && IOtArr?.map((url) => (
                <div style={{backgroundImage: `url(/assets/images/offlineCourseDetail/gallery/${url})`}}></div>
                 ))}
              </span>
            </div>
        </div>
        <div className='C2wScrollerParallax C2wScrollerParallax2'>
            <div className='C2wImageScorller'>
               <span>
                { pythonArr && pythonArr?.map((url) => (
                <div style={{backgroundImage: `url(/assets/images/offlineCourseDetail/gallery/${url})`}}></div>
                 ))}
              </span>
            </div>
        </div>
        <div className='C2wScrollerParallax C2wScrollerParallax1'>
          {/* IOT Superx and with three thumbnail from each photos  */}
            <div className='C2wImageScorller'>
              <span>
                { flutterArr && flutterArr?.map((url) => (
                <div style={{backgroundImage: `url(/assets/images/offlineCourseDetail/gallery/${url})`}}></div>
                 ))}
              </span>
            </div>
        </div>
    </div>
  )
}

export default C2wScrollerFramer;
